<template>
    <div class="police_detail">
        <div class="contain">
            <img v-for="item in picList" :key="item.id" :src="item.imgUrl | transImgUrl" alt />
        </div>
        <div class="chaining" v-if="detail.serviceName === '互联网医院'||detail.serviceName === '居家环境适老化改造'">
            <p>相关链接</p>
            <img class="line" src="@/assets/images/分割线.png" alt />

            <div style="marginBottom:20px" v-if="detail.serviceName === '互联网医院'">
                <a href="https://mp.weixin.qq.com/s/lg6IQl5nWP29ztDuBiHDLw">
                    <div class="guide">互联网医院操作指南</div>
                </a>
                <!-- <a
                    href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MjM5MzQyOTc5OA==&scene=124&uin=&key=&devicetype=Windows+10+x64&version=6302019a&lang=zh_CN&a8scene=7&fontgear=2"
                >
                    <div >
                        <div class="guide_top">互联网医院入口</div>
                        <div class="guide_bot">点击进入</div>
                    </div>
                </a> -->
<!-- 
                <img src="@/assets/images/外部公众号.jpg" alt="" class="guide_entry"> -->
            </div>

            <div style="marginBottom:20px" v-if="detail.serviceName === '居家环境适老化改造'">
                <a href="https://mp.weixin.qq.com/s/-2CQrPPRwdESnV-BNNhKXQ">
                    <div class="guide">政策解读</div>
                </a>
                <a href="https://mp.weixin.qq.com/s/L1jfI1KsQlOUxZs0fT1_XA">
                    <div class="guide">南京东路街道适老化智慧养老展示体验中心介绍</div>
                </a>
            </div>
        </div>
        <div class="bot">
            <bottom-button
                :phone="detail.phone"
                word=""
                :pic="require('@/assets/images/wx.png')"
                @right-click="onlineRequst"
            ></bottom-button>
        </div>
    </div>
</template>

<script>
import { getServiceDetail } from "@/api/service.js";
import { mapState } from "vuex";
export default {
    name: "PoliceDetail",
    data() {
        return {
            detail: {},
            picList: []
        };
    },
    methods: {
        onlineRequst() {
          if(!window.localStorage.getItem("openId")){
            this.$router.push({
              name:'login'
            });
            return false;
          }
            this.$router.push("/applyOnline");
        },
        async getData() {
            const res = await getServiceDetail(this.$route.query.id);
            this.detail = res;
            this.picList = res.servicePictures;
        }
    },
    computed: {
        ...mapState("service", ["serviceProjectId"])
    },
    mounted() {
        this.getData();
        window.document.title = this.$route.query.serviceName;
    }
};
</script>

<style lang="scss" scoped>
.police_detail {
    padding-bottom: 50px;
    .logo {
        width: 100%;
        height: 150px;
        margin-bottom: 20px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .contain {
        img {
            width: 100%;
        }
    }

    .chaining {
        text-align: center;
        p {
            opacity: 1;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            color: #757a8c;
            line-height: 28px;
            text-align: center;
        }

        .line {
            width: 227px;
        }

        .guide {
            opacity: 1;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: center;
            color: #7dceff;
            line-height: 40px;
        }

        // .guide_entry {
        //     width: 100px;
        //     height: 100px;
        // }
    }

    .bot {
        width: 100%;
        position: fixed;
        bottom: 0;
    }
}
</style>
